import styled, { css } from 'styled-components';

export const Container = styled.div`
  background: #FFF;
  height: 24px;
  border-radius: 0.25rem;
  padding: 12px;
  width: 100%;
  border: 1px solid var(--gray-100);
  margin-bottom: 20px ;
  display: flex;
  align-items: center;
  position: relative;

  ${props => (props.isErroded && !props.isFilled) && css`
    border-color: #ff073a;
  `}

  ${props => props.isFocused && css`
    transition: .4s;
    border-color: #66afe9;
    outline: 0;
    box-shadow: 0px 1px 8px #66afe9;
  `}

  ${props => (props.isErroded && props.isFocused) && css`
  border-color: #ff073a;
  box-shadow: 0px 1px 8px #dc3545;
  `}

  ${props => (props.isFilled && props.isFocused) && css`
    color: var(--color-primary);
    border-color: #66afe9;
    outline: 0;
    box-shadow: 0px 1px 8px #66afe9;
  `}
  input {
    flex: 1;
    background: transparent;
    border: 0;
    width: 100%;
    margin-right: 10px;
    color: var(--color-500);
    font-size: 0.9rem;

    &&::placeholder {
      color: #333333;
    }
  }

  button  {
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    position: absolute;
    height: 24px;
    width: 30px;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #FFF;

    svg {
      padding: 0;
    }
  }
`;

export const Error = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  svg {
    padding: 0;
    padding-left: 12px;
    margin: 0;
    cursor: auto;
  }

  span {
    color: #ff073a;
    font-size: 0.8rem;
    position: absolute;
    top: 25px;
    left: 0;
  }
`;
